module.exports = __webpack_public_path__ + "static/elephant-360-b479bdc7b895900449d2db4bf8d4e7bf.mp4";